import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./shared";

export default function Interludio() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="relative h-[62vh] min-h-[420px] overflow-hidden" data-testid="photo-interlude">
      <motion.img
        src="/assets/lago-acqua-chiara.jpg"
        alt="L'Isola di San Giulio vista dalla riva del Lago d'Orta, fotografata da Patrizia Franzina"
        className="absolute inset-0 h-[124%] w-full object-cover"
        style={{ y }}
      />
      <div className="absolute inset-0 bg-lake-deep/45" />
      <div className="relative z-10 flex h-full items-center justify-center px-6 text-center">
        <Reveal>
          <p className="mx-auto max-w-3xl font-serif text-2xl italic leading-snug text-parchment-ivory drop-shadow-lg sm:text-3xl lg:text-4xl">
            «Ogni pagina del romanzo è un luogo che puoi camminare.»
          </p>
          <p className="mt-5 text-[11px] uppercase tracking-[0.35em] text-parchment-ivory/75">
            Lago d'Orta · Fotografie dell'autrice
          </p>
        </Reveal>
      </div>
    </section>
  );
}
